import axios from 'axios';

export default {

	async createTablePage(doc, samples, customer, settings, analyses) {
		let columns = this.filterColumns(samples, analyses);
		let PageColumns = []
		let maxLength
		// if the width is wider than 760, the program will crash
		let widthLimit = 760

		/**
		 * 	TODO
		 *
		 *	Improve this so instead of checking after we push into PageColumns we calculate the width of each group and fill as many groups on each page
		 * 	If we do this, dont forgot that provnr, år and kundnr wont be printed on each group. But only on each page. 
		 *	So when calculating width of each group, dont use the filterColumns method since it will include those three columns.
		 */

		// If the columns will be wider than than the widthlimit we will have to split them up into groups
		if (this.getColumnsWidth(columns, settings) > widthLimit) {
			PageColumns.push(this.filterColumns(samples, analyses.filter(analysis => [1, 2].includes(analysis.group_id))))

			// columns width - page1 columns width = page2 columns width. If too wide, split again
			if (this.getColumnsWidth(columns, settings) - this.getColumnsWidth(PageColumns[0], settings) > widthLimit) {
				PageColumns.push(this.filterColumns(samples, analyses.filter(analysis => [3, 4, 5, 6].includes(analysis.group_id))))
				PageColumns.push(this.filterColumns(samples, analyses.filter(analysis => [7, 0].includes(analysis.group_id))))
			} else {
				PageColumns.push(this.filterColumns(samples, analyses.filter(analysis => [3, 4, 5, 6, 7, 0].includes(analysis.group_id))))
			}

			maxLength = 0
			PageColumns.forEach(col => maxLength = (col.length > maxLength ? col.length : maxLength))
		} else {
			PageColumns.push(columns)
			maxLength = columns.length
		}

		let chunkSize = maxLength > 13 ? 28 : 44;

		let base64Logo = await this.fetchImage()

		let chunks = this.chunkArray(samples.sort((a, b) => a.provnr - b.provnr), chunkSize);
		
		chunks.forEach((chunk, i) => {
			PageColumns.forEach(columns => {
				doc.addPage({
					size: 'a4',
					layout: maxLength > 13 ? 'landscape' : 'portrait'
				});
				doc.fontSize(12);
				doc.font('Times-Roman');

				doc.text(`Sida ${i+1} av ${chunks.length}`, 20, 20, {
					align: 'right'
				});

				doc.image(base64Logo, 20, 10, {
					width: 100
				});

				this.addCustomerData(doc, customer)
				this.createHeader(doc, columns, settings);
				this.addRows(doc, columns, chunk, settings);
			})
		});

		return await doc;
	},

	async fetchImage() {
		return new Promise((resolve) => {
			axios.get('/hs-logotype')
				.then((response) => resolve(response.data))
		})
	},

	createHeader(doc, columns, settings) {
		doc.fontSize(settings.fontSize);
		doc.font(settings.font);
	
		let currX = settings.left;
		columns.forEach(col => {
			doc.rect(currX, settings.top, col.width, settings.cellHeight).fillAndStroke('#7ca333', '#000')
			doc.fill('black');
			doc.text(col.text, currX + settings.columnPadding, settings.top + 5);
			currX += col.width;
		});
	},
	
	addRows(doc, columns, samples, settings) {
		doc.fontSize(settings.fontSize);
		doc.font('Times-Roman');
	
		let currX = settings.left;
		let currY = settings.top + 15;
		let text
		let nbrDecimals
		samples.forEach(sample => {
			columns.forEach(col => {
				doc.rect(currX, currY, col.width, settings.cellHeight).stroke()

				if(col.slug === 'p_al_klass' && sample['p_al']) {
					text = this.getPclass(sample['p_al']);
					doc.text(text, currX + 3, currY + 5);
				} else if(col.slug === 'k_al_klass' && sample['k_al']) {
					text = this.getKclass(sample['k_al']);
					doc.text(text, currX + 3, currY + 5);
				} else if(sample[col.slug]) {
					if(isNaN(sample[col.slug]) ||sample[col.slug] === null ||sample[col.slug].length === 0 ) {
						text = sample[col.slug]
					} else {
						nbrDecimals = ['x_3021','y_3021','year','provnr','customer_id','ca_al'].includes(col.slug) ? 0 : 1
						text = parseFloat(sample[col.slug]).toFixed(nbrDecimals)
					}
					doc.text(text, currX + 3, currY + 5);
				}

				currX += col.width;
			});

			currX = settings.left;
			currY += 15;
		});
	},

	addCustomerData(doc, customer) {
		doc.fontSize(15);
		doc.font('Times-Bold');
		doc.text('Analysrapport', 0, 20, {
			align: 'center'
		});
		doc.fontSize(12);
		doc.font('Times-Roman');
		doc.text(customer.title + "\n" + customer.adress + "\n" + customer.post_nbr + " " + customer.post_adress, 0, 40, {
			align: 'center'
		});
	},
	
	filterColumns(samples, providedAnalyses) {
		let analysisUsed = {}
		providedAnalyses.forEach(analysis => {
			analysisUsed[analysis.slug] = false
		})

		let cols = [
			// {text: 'X', slug: 'x_3021', width: 40},
			// {text: 'Y', slug: 'y_3021', width: 40},
			{ text: 'Provnr', slug: 'provnr', width: 35 },
			{ text: 'År', slug: 'year', width: 25 },
			{ text: 'Kundnr', slug: 'customer_id', width: 45 },
		];

		providedAnalyses.forEach(analysis => {
			// Wont add the 'ovrigt' analysis
 			if(analysis.slug !== 'ovrigt') {
				samples.forEach(sample => {
					// Check if the column already exists and if the sample has the analysis
					if (!analysisUsed[analysis.slug] && sample[analysis.slug]) {
						// Add the column if it is not already used
						analysisUsed[analysis.slug] = true
						cols.push({
							text: analysis.legendTitle ? analysis.legendTitle : analysis.title,
							slug: analysis.slug,
							width: analysis.width
						})
	
						if (analysis.slug == 'k_al' || analysis.slug == 'p_al') {
							cols.push({
								text: (analysis.legendTitle ? analysis.legendTitle : analysis.title) + ' klass',
								slug: analysis.slug + '_klass',
								width: analysis.width + 18
							})
						}
					}
				})
			}
		});

		return cols;
	},
	
	chunkArray(myOriginalArray, chunk_size) {
		let results = [];
		const myArray = [...myOriginalArray]
		
		while (myArray.length) {
			results.push(myArray.splice(0, chunk_size))
		}
		
		return results;
	},

	getPclass(value) {
		return value >= 16 ? 'V' :
			value >= 12 ? 'IVb' :
			value >= 8 ? 'IVa' :
			value >= 4 ? 'III' :
			value >= 2 ? 'II' :
			'I';
	},

	getKclass(value) {
		return value >= 32 ? 'V' :
			value >= 16 ? 'IVa' :
			value >= 8 ? 'III' :
			value >= 4 ? 'II' :
			'I';
	},

	getColumnsWidth(columns, settings) {
		return columns.reduce((sum, col) => {
			return sum += col.width + settings.columnPadding
		}, 0)
	}

}